import { isActionValid } from '../../Helpers/Reducer.helper';

import { INeoAction } from './../Actions.interface';
import { BOOKING_LIST_ACTIONS } from '../../Constants/Actions.constants';

const useValidAction = isActionValid([BOOKING_LIST_ACTIONS.CHECKIN_STATUS]);

interface OpenCheckinsState {
  [key: string]: boolean;
}

export default (state: OpenCheckinsState = {}, action: INeoAction) => {
  const { name, payload } = action;

  const actionValid = useValidAction(name);

  if (actionValid) {
    if (name == BOOKING_LIST_ACTIONS.CHECKIN_STATUS) {
      const { eventId, status } = payload;
      return {
        ...state,
        [eventId]: status,
      };
    }
  }

  return state;
};
